export default "__VITE_ASSET__By9ZiHnI__"